import { Component, EventEmitter, input, Input, OnChanges, Output } from '@angular/core';
import { NgClass } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';
import { ShortDatePipe } from '../../../../shared/pipes/short-date.pipe';

@Component({
    selector: 'app-person-error',
    templateUrl: './person-error.component.html',
    styleUrls: ['./person-error.component.scss'],
    imports: [
    NgClass,
    TranslatePipe,
    ShortDatePipe
],
})
export class PersonErrorComponent implements OnChanges {

    public date = input<Date, string | null>(new Date(), {
        transform: (it: string | null) => new Date(it || 'now'),
    });

    @Input() message: string = '';
    @Input() severity: 'error' | 'warning' = 'error';
    @Output() clickEvent = new EventEmitter();
    @Output() closeEvent = new EventEmitter();

    showError = true;

    protected clickable: boolean = false;
    protected closeable: boolean = false;

    public ngOnChanges(): void {
        this.clickable = this.clickEvent.observed;
        this.closeable = this.closeEvent.observed;
    }

}
